import { render, staticRenderFns } from "./bill_detail.vue?vue&type=template&id=06e566eb"
import script from "./bill_detail.vue?vue&type=script&lang=js"
export * from "./bill_detail.vue?vue&type=script&lang=js"
import style0 from "./bill_detail.vue?vue&type=style&index=0&id=06e566eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports